import React, { useRef, useEffect } from "react";
import "./Companies.css";
import AOS from "aos";
import "aos/dist/aos.css";

import hcl from "../../assets/hcl.png";
import tcs from "../../assets/tcs.png";
import turing from "../../assets/turing.png";
import genpact from "../../assets/genpact.png";
import lti from "../../assets/lti.png";

const Companies = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <section className="companies-section" id="companies">
      <h2
        className="companies-title"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        Companies I Have Worked With
        <span className="company-underline"></span>
      </h2>

      <div className="slider-wrapper" data-aos="fade-up" data-aos-delay="200">
        <button className="arrow left" onClick={scrollLeft}>&lt;</button>

        <div className="companies-slider" ref={sliderRef}>
          <div className="company-logo" data-aos="zoom-in" data-aos-delay="100">
            <img src={hcl} alt="HCL" />
          </div>
          <div className="company-logo" data-aos="zoom-in" data-aos-delay="200">
            <img src={tcs} alt="TCS" />
          </div>
          <div className="company-logo" data-aos="zoom-in" data-aos-delay="300">
            <img src={turing} alt="Turing" />
          </div>
          <div className="company-logo" data-aos="zoom-in" data-aos-delay="400">
            <img src={genpact} alt="Genpact" />
          </div>
          <div className="company-logo" data-aos="zoom-in" data-aos-delay="500">
            <img src={lti} alt="LTI Mindtree" />
          </div>
        </div>

        <button className="arrow right" onClick={scrollRight}>&gt;</button>
      </div>
    </section>
  );
};

export default Companies;
